<template>
    <div class="post-box">
        <!--<div class="post-media"
             :style="{ backgroundImage: 'url(http://icons.iconarchive.com/icons/martz90/circle-addon2/512/help-icon.png)'}"></div>-->
        <div class="post-content text-left">
            <h6 class="post-title">
                <!--{{ t.help_usage }}-->
                Mobile
            </h6>
            <div class="mobile-image">
                <img src="/static/assets/img/rivalo/mobileqr-code.png" alt="mobile-qr">
            </div>
            <div class="mobileBox-text">
                <div>Access the complete betting program from the palm of your hands!</div>
                <a href="/mobile">Click here for Mobile</a>
            </div>
            <p></p>
            <!--<a class="post-link" href="#"><i class="os-icon os-icon-arrow-right7"></i>
                <span>{{ t.detail }}</span>
            </a>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'mobileInfo',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/mobileinfo.vue